const defaultBookForm = {
  personal_form: {
    personal_details_section: { show: true },
    title: { show: true },
    full_name: { show: true },
    dob: { show: true },
    gender: { show: true },
    phone_code: { show: true },
    phone_number: { show: true },
    email: { show: true },
    alternate_email: { show: true },
    nationality: { show: true },
    home_address_line1: { show: true },
    home_address_line2: { show: true },
    home_address_country: { show: true },
    home_address_state: { show: true },
    home_address_city: { show: true },
    home_address_postal: { show: true },
    medical_condition: { show: true },
    medical_condition_value: { show: true },
    university_details_section: { show: true },
    university: { show: true },
    course: { show: true },
    enrolment_status: { show: true },
  },
  emergency_form: {
    title: { show: true },
    full_name: { show: true },
    dob: { show: true },
    email: { show: true },
    phone_code: { show: true },
    phone_number: { show: true },
    relation: { show: true },
    address_same_home: { show: true },
    address_addr_line1: { show: true },
    address_addr_line2: { show: true },
    address_country: { show: true },
    address_state: { show: true },
    address_city: { show: true },
    address_postal: { show: true },
  },
  guarantor_form: {
    same_as_emergency: { show: true },
    title: { show: true },
    full_name: { show: true },
    dob: { show: true },
    email: { show: true },
    phone_code: { show: true },
    phone_number: { show: true },
    relation: { show: true },
    address_line1: { show: true },
    address_line2: { show: true },
    address_country: { show: true },
    address_state: { show: true },
    address_city: { show: true },
    address_postal: { show: true },
  },
};

export default defaultBookForm;
